let selectedPlan = null;
let selectedProtection = null;

document.addEventListener("DOMContentLoaded", function() {
  window.plansPageVersion = 'A';

  $(".plans-hero-slideshow").slick({
    slidesToShow: 1,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev' id='plans-hero-slideshow-prev'><img src='https://cdn.shopify.com/s/files/1/0103/2847/3658/files/arrow.png?v=1697824273' width='35px' height='35px' alt=''/></button>",
    nextArrow:
      "<button type='button' class='slick-next'><img src='https://cdn.shopify.com/s/files/1/0103/2847/3658/files/arrow.png?v=1697824273' width='35px' height='35px' alt=''/></button>",
  });

  document.getElementById('plans-hero-slideshow-prev').click()
  document.getElementById('plans-hero-slideshow-prev').click()

  $(".plans-hero-slideshow").show();

  const plansPageHero = document.getElementById('plans-hero-content');

  const residentialPlan = document.getElementById('plans-hero-choose-plan-residential-plan');
  const travelPlan = document.getElementById('plans-hero-choose-plan-travel-plan');

  const standardProtection = document.getElementById('plans-hero-choose-standard-protection');
  const advancedProtection = document.getElementById('plans-hero-choose-advanced-protection');

  const plansPageChoosePlanStepOne = document.getElementById('plans-hero-step-one');
  const plansPageChoosePlanStepTwo = document.getElementById('plans-hero-step-two');
  const plansPageChoosePlanStepThree = document.getElementById('plans-hero-step-three');

  const plansPageCheckoutButton = plansPageHero.querySelector('#checkout-button');
  const plansPageCheckoutLinkResidentialStandard = plansPageHero.querySelector('#cb-residential-standard');
  const plansPageCheckoutLinkResidentialAdvanced = plansPageHero.querySelector('#cb-residential-advanced');
  const plansPageCheckoutLinkTravelStandard = plansPageHero.querySelector('#cb-travel-standard');
  const plansPageCheckoutLinkTravelAdvanced = plansPageHero.querySelector('#cb-travel-advanced');

  const selectResidentialPlan = () => {
    selectedPlan = 'residential';

    residentialPlan.classList.add('plans-hero-card-active');
    travelPlan.classList.remove('plans-hero-card-active');

    residentialPlan.querySelector('button span').innerText = 'RESIDENTIAL SELECTED';
    residentialPlan.querySelector('button svg').style.display = 'block';
    travelPlan.querySelector('button span').innerText = 'SELECT TRAVEL PLAN';
    travelPlan.querySelector('button svg').style.display = 'none';

    residentialPlan.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });
    $('.plans-hero-slideshow').slick('slickGoTo', 0);

    updateBottomBarPlan('residential')

    setTimeout(() => {
      plansPageChoosePlanStepTwo.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  const selectTravelPlan = () => {
    selectedPlan = 'travel';

    travelPlan.classList.add('plans-hero-card-active');
    residentialPlan.classList.remove('plans-hero-card-active');

    residentialPlan.querySelector('button span').innerText = 'SELECT RESIDENTIAL PLAN';
    residentialPlan.querySelector('button svg').style.display = 'none';
    travelPlan.querySelector('button span').innerText = 'TRAVEL SELECTED';
    travelPlan.querySelector('button svg').style.display = 'block';

    travelPlan.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });
    $('.plans-hero-slideshow').slick('slickGoTo', 1);

    updateBottomBarPlan('travel')

    setTimeout(() => {
      plansPageChoosePlanStepTwo.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  const selectStandardProtection = () => {
    selectedProtection = 'standard';

    standardProtection.classList.add('plans-hero-card-active');
    advancedProtection.classList.remove('plans-hero-card-active');

    standardProtection.querySelector('button span').innerText = 'STANDARD PROTECTION SELECTED';
    standardProtection.querySelector('button svg').style.display = 'block';
    advancedProtection.querySelector('button span').innerText = 'UPGRADE TO ADVANCED PROTECTION';
    advancedProtection.querySelector('button svg').style.display = 'none';

    standardProtection.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });

    setTimeout(() => {
      plansPageChoosePlanStepThree.scrollIntoView({ behavior: 'smooth' })
    }, 500);
  }

  const selectAdvancedProtection = () => {
    selectedProtection = 'advanced';

    advancedProtection.classList.add('plans-hero-card-active');
    standardProtection.classList.remove('plans-hero-card-active');

    standardProtection.querySelector('button span').innerText = 'CONTINUE WITH STANDARD PROTECTION';
    standardProtection.querySelector('button svg').style.display = 'none';
    advancedProtection.querySelector('button span').innerText = 'ADVANCED PROTECTION SELECTED';
    advancedProtection.querySelector('button svg').style.display = 'block';

    advancedProtection.querySelector('button').scrollIntoView({ behavior: 'smooth', block: 'center' });

    setTimeout(() => {
      plansPageChoosePlanStepThree.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  }

  const checkout = (plan, protection) => {
    if (plan === 'residential') {
      if (protection === 'standard') {
        plansPageCheckoutLinkResidentialStandard.click();
      } else if (protection === 'advanced') {
        plansPageCheckoutLinkResidentialAdvanced.click();
      } else {
        Toastify({
          text: "Please choose protection",
          duration: 3000,
          newWindow: true,
          gravity: "top",
          position: "center",
        }).showToast();

        plansPageChoosePlanStepTwo.scrollIntoView({ behavior: 'smooth' });

        return;
      }
    } else if (plan === 'travel') {
      if (protection === 'standard') {
        plansPageCheckoutLinkTravelStandard.click();
      } else if (protection === 'advanced') {
        plansPageCheckoutLinkTravelAdvanced.click();
      } else {
        Toastify({
          text: "Please choose protection",
          duration: 3000,
          newWindow: true,
          gravity: "top",
          position: "center",
        }).showToast();

        plansPageChoosePlanStepTwo.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      Toastify({
        text: "Please choose a plan",
        duration: 3000,
        newWindow: true,
        gravity: "top",
        position: "center",
      }).showToast();

      plansPageChoosePlanStepOne.scrollIntoView({ behavior: 'smooth' });
    }
  }

  residentialPlan.addEventListener('click', selectResidentialPlan);
  travelPlan.addEventListener('click', selectTravelPlan);
  standardProtection.addEventListener('click', selectStandardProtection);
  advancedProtection.addEventListener('click', selectAdvancedProtection);
  plansPageCheckoutButton.addEventListener('click', () => checkout(selectedPlan, selectedProtection))

  residentialPlan.querySelector('button').disabled = false;
  travelPlan.querySelector('button').disabled = false;
  standardProtection.querySelector('button').disabled = false;
  advancedProtection.querySelector('button').disabled = false;
  plansPageCheckoutButton.disabled = false;

  const searchParams = new URLSearchParams(window.location.search);

  switch (searchParams.get('plan')) {
    case 'residential':
      plansPageChoosePlanStepOne.scrollIntoView({ behavior: 'smooth' });
      break;
    case 'travel':
      plansPageChoosePlanStepOne.scrollIntoView({ behavior: 'smooth' });
      break;
  }

  initializeChargebeeProductTracking('cb-residential-standard', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'PLANSPAGECHECKOUT')
  initializeChargebeeProductTracking('cb-residential-advanced', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'PLANSPAGECHECKOUT')
  initializeChargebeeProductTracking('cb-travel-standard', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'PLANSPAGECHECKOUT')
  initializeChargebeeProductTracking('cb-travel-advanced', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'PLANSPAGECHECKOUT')
});
